"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useDragDropManager_1 = require("./internal/useDragDropManager");
var useDropTargetMonitor_1 = require("./internal/useDropTargetMonitor");
var useMonitorOutput_1 = require("./internal/useMonitorOutput");
var invariant = require('invariant');
/**
 * useDropTarget Hook (This API is experimental and subject to breaking changes in non-breaking versions)
 * @param spec The drop target specification
 */
function useDrop(spec) {
    var accept = spec.accept, options = spec.options, collect = spec.collect;
    invariant(accept != null, 'accept must be defined');
    var ref = spec.ref;
    if (!ref) {
        ref = react_1.useRef(null);
    }
    var manager = useDragDropManager_1.useDragDropManager();
    var backend = manager.getBackend();
    var monitor = useDropTargetMonitor_1.useDropTargetMonitor(manager, spec);
    /*
     * Connect the Drop Target Element to the Backend
     */
    react_1.useEffect(function connectDropTarget() {
        if (ref.current) {
            var node = ref.current;
            if (node) {
                return backend.connectDropTarget(monitor.getHandlerId(), node, options);
            }
        }
    });
    var result = collect
        ? useMonitorOutput_1.useMonitorOutput(monitor, collect)
        : {};
    return [result, ref];
}
exports.useDrop = useDrop;
